module.exports = __webpack_public_path__ + "img/card_quincy_background.dfdfa835.png";